import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import {
  IconButton,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import {
  Column,
  SimpleTable
} from '../../../../components/SimpleTable';
import {OrganizationUserModel} from '../../../../model/organization/organization-user.model';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

type Props = {
  users: OrganizationUserModel[]
  onUserLicensePermissionsClicked: (userId: string) => void
  onUserPermissionsClicked: (userId: string) => void
  translateLocal: (key: string) => string
  translate: (key: string) => string
}
export const OrganizationUsersTable = ({users, onUserLicensePermissionsClicked, onUserPermissionsClicked, translate, translateLocal}: Props) => {
  const columns: Column<OrganizationUserModel>[] = [
    { key: 'email', minWidth: 200, label: translateLocal('column.email'), render: (row) => {
      return <Box key={row.email} display="flex" alignItems="center" gap={1}>
        <IconButton onClick={() => onUserLicensePermissionsClicked(row.id)} aria-label={translate('common.details.title')}>
          <ManageAccountsIcon />
        </IconButton>
        <IconButton onClick={() => onUserPermissionsClicked(row.id)} aria-label={translate('common.details.title')}>
          <AdminPanelSettingsIcon />
        </IconButton>
        <Typography variant="body2">{row.email}</Typography>
      </Box>
    }},
    { key: 'id', minWidth: 200, label: translateLocal('column.id'), render: (row) => row.id },
    { key: 'externalUserId', minWidth: 200, label: translateLocal('column.externalUserId'), render: (row) => row.externalUserId },
  ]

  return <SimpleTable
    rows={[...users].sort((a, b) => a.email.localeCompare(b.email))}
    columns={columns}
    rowKey={(row) => row.id}
  />
}